import { get } from 'lodash';
import React from 'react';

import FailsafeImg from 'components/global/application/FailsafeImg';

import { Article } from 'types/drupal/ArticleNode';
import { InstrumentGroup } from 'types/drupal/InstrumentGroupNode';
import { InventoryInstrument } from 'types/drupal/InstrumentNode';

import './FeaturedItem.sass';

interface Props {
    content: Article | InstrumentGroup | InventoryInstrument;
}

const FeaturedItem: React.StatelessComponent<Props> = (props: Props) => {
    const { content } = props;

    /**
     * extract the image fid to used based on type
     */
    const getImgID = (data: any) => {
        switch (data.type) {
            case 'article' :
                return get(data, 'field_image.fid');
            case 'instrument_group' :
                return get(data, 'field_instrument_group_image.fid');
            case 'instrument' :
                return get(data, 'field_instr_image_first.fid');
            default :
                return false;
        }
    };

    return (
        <a key={content.nid} className="col-4 col-md-2 FeaturedItem-container" href={`/${content.alias}`}>
            <FailsafeImg
                alt={content.title}
                src={`${process.env.API_URL}/files/${getImgID(content)}?style=home_featured_image`}
            />
            <div className="title">{content.title}</div>
        </a>
    );
};

export default FeaturedItem;



// WEBPACK FOOTER //
// ./src/components/pages/home/FeaturedItem.tsx